import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { SubTasksController } from '../controller/SubTasksController';
import { Task } from '../../networkTasks/types';

export class SubTasksWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SubTasksController,
    });
  }

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, 'data-task'];
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  set task(value: Task | undefined) {
    if (typeof value === 'undefined') {
      this.removeAttribute('data-task');
    } else {
      this.setAttribute('data-task', JSON.stringify(value));
    }
  }

  get task(): Task | undefined {
    if (this.hasAttribute('data-task')) {
      const value = this.getAttribute('data-task');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

}
